import { TableProps } from '../props/shape/table/table-props';
import { TableStore } from '../store/table-store';
import { TableMutationAPI } from '../api/table-mutation-api';
import { GraphicFrameBaseDataModel } from './graphic-frame-base-data-model';
import type { PageContext } from '../context/page-context';
import type { IEventManager } from '../manager/event-manager';
import type { ITableProps } from '../props/shape/table/table-props';
import type { GroupShapeDataModel } from './group-shape-data-model';
import type { ITableData } from '../data';
import type { RestrictedDataModel } from './data-model';
import type { TableChangeType, TableCellUpdateType } from '../constants';

interface ITableChange {
    changeType: TableChangeType;
    updateType?: TableCellUpdateType[];
    row: number | 'all';
    col: number | 'all';
}

export type ITableChangeList = Array<ITableChange>;

export class TableDataModel extends GraphicFrameBaseDataModel<ITableData> {
    public store: TableStore;
    public props: ITableProps;
    public api: TableMutationAPI;
    private tableChangeList: ITableChangeList = [];

    public constructor(
        data: ITableData,
        events: IEventManager,
        context: PageContext,
        public parent: GroupShapeDataModel,
    ) {
        super(data, events, context, parent);

        this.store = new TableStore(data, events, this);
        this.props = new TableProps(this.store.data, this.context);
        this.api = new TableMutationAPI(this, events);
    }

    public get tableChanges(): Readonly<ITableChangeList> {
        return this.tableChangeList;
    }

    public addTableChange(change: ITableChange) {
        this.tableChangeList.push(change);
    }

    public clearTableChanges() {
        this.tableChangeList = [];
    }

    public get rowLength(): number {
        return this.props.graphic?.graphicData?.tbl?.tr?.length ?? 0;
    }

    public get colLength(): number {
        return this.props.graphic?.graphicData?.tbl?.tblGrid?.gridCol?.length ?? 0;
    }

    /**
     * 获取此 shape 在母版版式上相关联的 shapeModel（占位符）
     */
    public getRelatedPlaceholder() {
        return this.context.getPlaceholder(this.props.nvPr?.ph);
    }
}

export { type ITableProps };
export type ITableDataModel = RestrictedDataModel<TableDataModel>;
